module.exports = __webpack_public_path__ + "img/img_csf_operate@3x.f039e785.png";